import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { Flex } from "@ui"
import type { FC } from "react"

import { SaveOrCancelConfig } from "../-shared/SaveCancelConfig"
import type { SolutionSettings } from "../-shared/solutionSettings"
import { solutionSettingsQuery } from "../-shared/solutionSettings.query"
import { useSolutionSettingsState } from "../-shared/useSolutionSettingsState"
import { queryClient } from "../../../queryClient"
import { LiveSummaryConfig } from "./-components/LiveSummaryConfig"
import { QueuePromptPair } from "./-components/QueuePromptPair"

const LiveSummaryPageContent: FC<{
  initialState: SolutionSettings
}> = ({ initialState }) => {
  const {
    draftState,
    patchPayload,
    isDirty,
    setDraftState,
    resetDraftState,
    updateInitialSettings,
  } = useSolutionSettingsState(initialState)

  return (
    <SaveOrCancelConfig
      title="Live Summary"
      patchPayload={patchPayload}
      onReset={resetDraftState}
      onSave={updateInitialSettings}
      isDisabled={!isDirty}
    >
      <Flex
        gap="lg"
        flexDirection="column"
      >
        <LiveSummaryConfig
          checked={draftState.modules.liveSummary}
          liveSummary={draftState.liveSummary}
          onStateChange={setDraftState}
          locked={!draftState.modulesAccess.liveSummary}
        />
        <QueuePromptPair
          liveSummary={draftState.liveSummary}
          onStateChange={setDraftState}
          locked={!draftState.modulesAccess.liveSummary}
        />
      </Flex>
    </SaveOrCancelConfig>
  )
}

const LiveSummaryPage: FC = () => {
  const { data: solutionSettingsData } = useSuspenseQuery(solutionSettingsQuery)

  return (
    <LiveSummaryPageContent
      key={solutionSettingsData.solutionUid}
      initialState={solutionSettingsData}
    />
  )
}

export const Route = createFileRoute("/_authenticated/live-summary/")({
  loader: () => {
    return queryClient.ensureQueryData(solutionSettingsQuery)
  },
  component: LiveSummaryPage,
})
